var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAccountBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbae47;}.b{fill:#ec008c;font-size:32px;font-family:Rubik-Regular, Rubik;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-798 -170)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.271,65.53a26.367,26.367,0,0,1,14.558-.9c6.456,1.563,10.073,6.348,15.1,10.022,1.784,1.3,9.45,4.022,7.572-.732-1.643-4.158-5.546-7.7-9.088-10.23-5.557-3.96-11.4-5.314-18.242-5.392-5.359-.06-10.123,1.578-14.879,3.475C193.666,63.617,174.2,65.254,175.332,56c-1.907,15.591,4.315,34.163,21.209,38.425,5.454,1.376,10.275,1.725,14.441-2.348,8.075-7.9.2-21.98-7.711-26.547",
    transform: "translate(758 117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M217.554,69.45a1.976,1.976,0,1,1-.318-2.774A1.976,1.976,0,0,1,217.554,69.45Z",
    transform: "translate(758 117)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountBanner);
export default __webpack_public_path__ + "static/media/myAccountBanner.caa642d4d3436f5fb9886be466109fba.svg";
export { ForwardRef as ReactComponent };